import 'slick-carousel'

if(/^\//.test(location.pathname)){

$(() => {

  const $slide = $('[data-plugin="slider"]')
  $slide.slick({
    autoplay: true,
    arrows: false,
    dots: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
  })
  
})

}